module.exports = __webpack_public_path__ + "img/03ea9e1.png";